import React from 'react';
import { Link } from 'react-router-dom';
import './SampleComponent.css';

const SampleComponent = () => {
  return (
    <div className="sample-container">
      <img src="/logo.jpg" alt="RSMIN Education Grant Portal" className="landing-logo" />
      <h1>Welcome to the RSMIN Portal</h1>
      <p>Your comprehensive management system.</p>
      
      <div className="feature-cards">
        <div className="feature-card">
          <h3>User Dashboard</h3>
          <p>Access your personalized dashboard to manage all features.</p>
          <Link to="/user-dashboard" className="feature-link">Go to Dashboard</Link>
        </div>
      </div>
      {/* <p>Powered by Goondocks 2025.</p> */}
    </div>
  );
};

export default SampleComponent;